<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header">
          <h3>개인정보처리방침</h3>
        </div>

        <div class="section-body">
          <!--- agree1 -->
          <dl class="field-group vertical">
            <dt class="field-label wfull">
              <h4 role="heading" tabindex="0">
               LG유플러스 온세일(홈)(https://onsalehome.uplus.co.kr/)에서 이용할 수 있는 판매점 영업 지원 시스템, 이하 ”온세일(홈)”은 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.
<br/><br/>
온세일(홈)은 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.
<br/><br/>
○ 본 방침은 2020년 7월 10일부터 시행됩니다.
<br/><br/>
<strong>1. 개인정보의 처리 목적</strong><br/>
온세일(홈)은 개인정보를 홈페이지 회원가입 및 관리(회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 각종 고지·통지 등)를 위해 처리합니다. 수집된 개인정보는 홈페이지 회원가입 및 관리 목적 이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전에 동의를 받습니다.
<br/><br/>
<strong>2. 처리하는 개인정보 항목</strong><br/>
온세일(홈)은 다음의 개인정보 항목을 처리합니다.<br/>
- 아이디, 성명, 생년월일, 성별, 비밀번호, 전화번호, 통신사, 통신사번호, 이메일, 접속로그, 서비스 이용로그, IP, MAC
<br/><br/>
<strong>3. 개인정보의 수집방법</strong><br/>
온세일(홈)은 다음과 같이 개인정보를 수집합니다.<br/>
서비스 이용과정 중 자동수집: 아이디, 성명, 생년월일, 성별, 비밀번호, 전화번호, 통신사, 통신사번호, 이메일, 접속로그, 서비스 이용로그, IP, MAC
<br/><br/>
<strong>4. 개인정보의 처리 및 보유 기간</strong><br/>
① 온세일(홈)은 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.<br/>
② 개인정보 처리 및 보유 기간은 수집∙이용에 관한 동의일로부터 [서비스 해지 또는 미접속 후 2개월 후 삭제]까지입니다.
<br/><br/>
<strong>5. 개인정보의 제 3자 제공에 관한 사항</strong><br/>
온세일(홈)은 개인정보를 제3자에게 제공하지 않습니다.
<br/><br/>
<strong>6. 개인정보처리 위탁</strong><br/>
① 온세일(홈)은 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.<br/>
- 위탁받는 자 (수탁자) : LGCNS<br/>
- 위탁하는 업무의 내용 : 온세일(홈) 시스템 운영<br/>
② 온세일(홈)은 위탁계약 체결시 개인정보 보호법 제25조에 따라 위탁업무수행목적 외 개인정보 처리금지, 기술적∙관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리∙감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.<br/>
③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.
<br/><br/>
<strong>7. 정보주체와 법정대리인의 권리·의무 및 그 행사방법</strong> <br/>
① 정보주체는 온세일(홈)에 대해 언제든지 개인정보 열람, 정정, 삭제, 처리정지 요구 등의 권리를 행사할 수 있습니다.<br/>
② 제1항에 따른 권리 행사는 온세일(홈)에 대해 개인정보 보호법 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 온세일(홈)은 이에 대해 지체 없이 조치하겠습니다.<br/>
③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.<br/>
④ 개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조 제5항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다.<br/>
⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.<br/>
⑥ 온세일(홈)은 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
<br/><br/>
<strong>8. 개인정보의 파기</strong><br/>
① 온세일(홈)은 수집한 개인정보 처리목적이 달성되거나 그 보유∙이용기간이 종료되는 경우에는 지체없이 해당 개인정보를 파기합니다. <br/>
② 회사는 서면에 기재된 개인정보의 경우에는 분쇄기로 분쇄하거나 소각하며 전자적 방법으로 저장된 개인정보의 경우에는 그 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
<br/><br/>
<strong>9. 개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항</strong><br/>
온세일(홈)은 정보주체의 이용정보를 저장하고 수시로 불러오는 ‘쿠키’를 사용하지 않습니다.
<br/><br/>
<strong>10. 개인정보 보호책임자</strong><br/>
① 온세일(홈)은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다. 
<br/><br/>
<strong>▶ 개인정보보호책임자</strong> <br/>
성명 : 홍관희<br/>
전화 : 1544-0010,101,114(이동전화)<br/>
메일 : securitypol@lguplus.co.kr<br/>
<br/><br/>
② 정보주체는 온세일(홈)의 서비스(또는 사업)을 이용하면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다. 온세일(홈)은 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.
<br/><br/>
<strong>11. 개인정보 처리방침 변경</strong> <br/>
개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
<br/><br/>
<strong>12. 개인정보의 안전성 확보 조치</strong> <br/>
온세일(홈)은 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.<br/>
① 정기적인 자체 감사 실시: 개인정보 취급 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체 감사를 실시하고 있습니다.<br/>
② 개인정보 취급 직원의 최소화 및 교육: 개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을 시행하고 있습니다.<br/>
③ 내부관리계획의 수립 및 시행: 개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.<br/>
④ 해킹 등에 대비한 기술적 대책: 온세일(홈)은 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.<br/>
⑤ 개인정보의 암호화: 이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.<br/>
⑥ 접속기록의 보관 및 위변조 방지: 개인정보처리시스템에 접속한 기록을 최소 6개월 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능을 사용하고 있습니다.<br/>
⑦ 개인정보에 대한 접근 제한: 개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.<br/>
⑧ 문서보안을 위한 잠금장치 사용: 개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.<br/>
⑨ 비인가자에 대한 출입 통제: 개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.
<br/><br/>
<strong>13. 고지의 의무</strong><br/>
개인정보처리방침은 2020년 10월 1일부터 시행되며 정부의 정책 또는 보안기술의 변경에 따라 내용의 추가∙삭제 및 수정이 있을 시에는 개정 전에 온세일(홈)의 "공지"란을 통해 고지합니다.
<br/><br/>
개인정보처리방침 버전번호 : V20201001
<br/><br/>
개인정보처리방침 시행일: 2020-10-01
<br/><br/>
              </h4>
            </dt>
            
          </dl>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnsaleHomeRules',

  props: {},

  data() {
    return {}
  },

  computed: {
    
  },

  methods: {}
}
</script>

<style scoped></style>
